import common from "./common";
import cloudInterface from "@/views/cloudInterface/cloudInterface.en";
import admin from "@/views/admin/admin.en";
import login from "@/views/login/login.en";
import statistics from "@/views/statistics/statistics.en";
import screen from "@/views/screen/screen.en";
import components from "@/components/components.en";
import cn from '../zh-CN/index'

import install from "@/views/install/install.en";
const locale = {
  common,
  cloudInterface,
  admin,
  login,
  statistics,
  screen,
  components,
  install
};

function getKeys(currentKey = '', locale, localeCN) {
  for (const key in localeCN) {
    if (typeof localeCN[key] === 'string') {
      let has
      try {
        has = locale.hasOwnProperty(key)
      } catch (error) {
        console.log(currentKey + '.' + key);
      }
      if (has) {

      } else {
        console.log(currentKey + '.' + key);
      }
    } else {
      getKeys(key, locale[key], localeCN[key])
    }
  }
}

getKeys('', locale, cn)
export default locale;



// WEBPACK FOOTER //
// ./src/locale/lang/en/index.js